/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

function MiniEpgEmptyChannelMessage({
  emptyChannelsMessage,
  isForYouCategory,
}) {
  return (
    <div className={`dtv-html5-c-mini-epg__empty-schedules-categories ${isForYouCategory ? 'dtv-html5-c-mini-epg__empty-schedules-categories--for-you' : ''}`}>
      <span>
        {emptyChannelsMessage.title}
      </span>
      <span>
        {emptyChannelsMessage.description}
      </span>
    </div>
  );
}

MiniEpgEmptyChannelMessage.propTypes = {
  emptyChannelsMessage: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  isForYouCategory: PropTypes.bool,
};

MiniEpgEmptyChannelMessage.defaultProps = {
  emptyChannelsMessage: PropTypes.shape({
    title: '',
    description: '',
  }),
  isForYouCategory: false,
};

export default memo(MiniEpgEmptyChannelMessage);
